export const UPDATE_USERS_SUCCESS = "UPDATE_USERS_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const DELETE_INVITATION_SUCCESS = "DELETE_INVITATION_SUCCESS";
export const LOAD_INVITATIONS_SUCCESS = "LOAD_INVITATIONS_SUCCESS";
export const SEND_INVITATION_SUCCESS = "SEND_INVITATION_SUCCESS";
export const BLOCK_USER_SUCCESS = "BLOCK_USER_SUCCESS";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const GET_USER_ROLES_SUCCESS = "GET_USER_ROLES_SUCCESS";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const UPDATE_ORGANIZATION_SUCCESS = "UPDATE_ORGANIZATION_SUCCESS";
export const LOAD_ORGANIZATION_SUCCESS = "LOAD_ORGANIZATION_SUCCESS";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const GET_TOTAL_FILES_UPLOADED_BY_MONTH =
  "GET_TOTAL_FILES_UPLOADED_BY_MONTH";
export const GET_TOTAL_SCORED_USERS_BY_MONTH =
  "GET_TOTAL_SCORED_USERS_BY_MONTH";
export const GET_FSDS_TOTAL_CALLS_BY_MONTH_SUCCESS =
  "GET_FSDS_TOTAL_CALLS_BY_MONTH_SUCCESS";
export const GET_FSDS_CHARGEABLE_CALLS_BY_MONTH_SUCCESS =
  "GET_FSDS_CHARGEABLE_CALLS_BY_MONTH_SUCCESS";
export const GET_FSDS_CHARGEABLE_CALLS_SUCCESS =
  "GET_FSDS_CHARGEABLE_CALLS_SUCCESS";
export const GET_FSDS_TOTAL_CALLS_SUCCESS = "GET_FSDS_TOTAL_CALLS_SUCCESS";
export const GET_TOTAL_SCORED_BY_MONTH_SUCCESS =
  "GET_TOTAL_SCORED_BY_MONTH_SUCCESS";
export const GET_SCORED_FILES_SUM_SUCCESS = "GET_SCORED_FILES_SUM_SUCCESS";
export const DESTROY_FILE_SUCCESS = "DESTROY_FILE_SUCCESS";
export const LOAD_APP_LIST_SUCCESS = "LOAD_APP_LIST_SUCCESS";
export const COUNTRIES_SUCCESS = "COUNTRIES_SUCCESS";
export const FINSTREAM_APPS_SUCCESS = "FINSTREAM_APPS_SUCCESS";
export const FINCLUDE_APPS_SUCCESS = "FINCLUDE_APPS_SUCCESS";
export const CREATE_ORGANIZATION_SUCCESS = "CREATE_ORGANIZATION_SUCCESS";
export const FINSCORE_FILE_UPLOADS_SUCCESS = "FINSCORE_FILE_UPLOADS_SUCCESS";
export const SUCCESS_RATE_SUCCESS = "SUCCESS_RATE_SUCCESS";
export const TOTAL_CHARGEABLE_CALLS_SUCCESS = "TOTAL_CHARGEABLE_CALLS_SUCCESS";
export const TOTAL_API_CALLS_SUCCESS = "TOTAL_API_CALLS_SUCCESS";
export const FILE_SUCCESS = "FILE_SUCCESS";
export const FILES_SUCCESS = "FILES_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOAD_CURRENT_USER_SUCCESS = "LOAD_CURRENT_USER_SUCCESS";
export const LOAD_APPLICATIONS_SUCCESS = "LOAD_APPLICATIONS_SUCCESS";
export const LOAD_APPLICATION_SUCCESS = "LOAD_APPLICATION_SUCCESS";
export const SAVE_APPLICATION_SUCCESS = "SAVE_APPLICATION_SUCCESS";
export const DELETE_APPLICATION_SUCCESS = "DELETE_APPLICATION_SUCCESS";
export const UPDATE_APPLICATION_SUCCESS = "UPDATE_APPLICATION_SUCCESS";
